import { Text } from '@mantine/core';
import { ReactNode } from 'react';

export const ConditionalComponent= ({ condition, label, children }: {
    condition?: boolean;
    label: string;
    children: ReactNode;
}) => {
    return (
        <>
            {condition ?
                children
            :   <div
                    style={{
                        display: 'flex',
                        overflowY: 'hidden',
                        width: '100%',
                        height: '100%',
                    }}
                >
                    <div
                        style={{
                            textAlign: 'center',
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <Text fs={'italic'}>{label}</Text>
                    </div>
                </div>
            }
        </>
    );
};
